import React, { useState } from "react";
import { ArrowLeft, DropDownBold } from "../AdminIcons";
import { useNavigate } from "react-router-dom";
import AddCourseModal from "./AddCourseModal";
import { ChevronDown } from "lucide-react";
import { useGetAllCategoriesQuery } from "../../services/categories/categoriesApi";

const CATEGORY_FILTER_LABEL = "All Categories";
const STATUS_FILTER_LABEL = "Status";
const PRICE_FILTER_LABEL = "Price Range";

const PRICE_RANGE_OPTIONS = [
  { label: "Under Rs1000", min: "", max: "1000" },
  { label: "Rs1000 - Rs2000", min: "1000", max: "2000" },
  { label: "Rs2000 - Rs3000", min: "2000", max: "3000" },
  { label: "Rs3000+", min: "3000", max: "" },
];

const STATIC_FILTERS = [
  {
    label: STATUS_FILTER_LABEL,
    options: ["Active", "Inactive", "Published", "Unpublished"],
  },
  {
    label: PRICE_FILTER_LABEL,
    options: PRICE_RANGE_OPTIONS.map((range) => range.label),
  },
];

const Header = ({ onCategoryChange, onStatusChange, onPriceRangeChange }) => {
  const navigate = useNavigate();
  const [isAddCourseMenuOpen, setIsAddCourseMenuOpen] = useState(false);
  const [isAddCourseModalOpen, setIsAddCourseModalOpen] = useState();
  const [openFilter, setOpenFilter] = useState(null);

  const [selectedFilters, setSelectedFilters] = useState({});

  const { data: categoriesData } = useGetAllCategoriesQuery();
  const categories = categoriesData?.data || [];

  const FILTERS = [
    {
      label: CATEGORY_FILTER_LABEL,
      options: [
        CATEGORY_FILTER_LABEL,
        ...categories.map((category) => category.categoryName),
      ],
    },
    ...STATIC_FILTERS,
  ];

  const handleSelectFilter = (label, option) => {
    setSelectedFilters((current) => ({
      ...current,
      [label]: option,
    }));

    setOpenFilter(null);

    if (label === CATEGORY_FILTER_LABEL && typeof onCategoryChange === "function") {
      if (option === CATEGORY_FILTER_LABEL) {
        onCategoryChange("");
      } else {
        const matchedCategory = categories.find(
          (category) => category.categoryName === option,
        );
        onCategoryChange(matchedCategory?._id || "");
      }
    }

    if (label === STATUS_FILTER_LABEL && typeof onStatusChange === "function") {
      onStatusChange(option);
    }

    if (label === PRICE_FILTER_LABEL && typeof onPriceRangeChange === "function") {
      const matchedRange = PRICE_RANGE_OPTIONS.find(
        (range) => range.label === option,
      );
      onPriceRangeChange({
        priceMin: matchedRange?.min || "",
        priceMax: matchedRange?.max || "",
      });
    }
  };

  const handleClearFilters = () => {
    setSelectedFilters({});
    setOpenFilter(null);

    if (typeof onCategoryChange === "function") {
      onCategoryChange("");
    }

    if (typeof onStatusChange === "function") {
      onStatusChange("");
    }

    if (typeof onPriceRangeChange === "function") {
      onPriceRangeChange({ priceMin: "", priceMax: "" });
    }
  };
  return (
    <div className="">
      <div className="bg-[#F4F4F466] px-3 2xl:pl-1.5 py-4 2xl:pt-5 2xl:pb-7 2xl:pr-7">
        <button type="button" onClick={() => navigate(-1)}>
          <ArrowLeft />
        </button>
        <div className="mt-3 2xl:mt-[18px] flex flex-col sm:flex-row sm:flex-wrap items-center sm:justify-between gap-4">
          <h2 className="text-xl sm:text-2xl  font-bold   text-[#111827] leading-[26px]">
            Course Management
          </h2>

          <div className="flex flex-wrap items-center justify-end gap-3">
            <button
              type="button"
              onClick={() => {
                navigate("/admin/course-management/view-category");
              }}
              className="inline-flex items-center gap-4 rounded-md bg-[#923D8C] px-2.5 py-2 text-lg font-medium leading-5 text-white transition hover:opacity-95"
            >
              <span>View Categories</span>
            </button>

            <div className="relative">
              <button
                type="button"
                onClick={() => setIsAddCourseMenuOpen((current) => !current)}
                className="inline-flex items-center gap-4 rounded-md bg-[#923D8C] px-3 py-2 text-lg font-medium leading-5 text-white transition hover:opacity-95"
              >
                <span>Add Course</span>
                <DropDownBold />
              </button>

              {isAddCourseMenuOpen ? (
                <div className="absolute right-0 top-[calc(100%+6px)] z-30 w-[142px] border border-[#A6A6A6B5] bg-[#E3E3E3] py-2">
                  {["Create category", "Add new course"].map((option) => (
                    <button
                      key={option}
                      type="button"
                      onClick={() => {
                        if (option === "Create category") {
                          navigate("/admin/course-management/view-category", {
                            state: { openAddCategoryModal: true },
                          });
                        }
                        if (option === "Add new course") {
                          setIsAddCourseModalOpen(true);
                        }

                        setIsAddCourseMenuOpen(false);
                      }}
                      className="block w-full px-3 py-1 text-left text-[15px] font-normal leading-[18px] text-[#111111]"
                    >
                      {option}
                    </button>
                  ))}
                </div>
              ) : null}
            </div>
          </div>
        </div>
        <div className="mt-3 flex flex-wrap items-center gap-2.5">
          {FILTERS.map((filter, idx) => {
            const { label, options } = filter;

            const selectedValue = selectedFilters[label] || "";
            const isOpen = openFilter === label;

            return (
              <div key={`filter-${idx}`} className="relative">
                <button
                  type="button"
                  onClick={() =>
                    setOpenFilter((current) =>
                      current === label ? null : label,
                    )
                  }
                  className={`inline-flex capitalize items-center gap-2 rounded-full border px-2.5 py-[4.5px] text-sm font-medium leading-none transition ${
                    selectedValue
                      ? "border-[#923D8C] bg-[#F5ECF4] text-[#923D8C]"
                      : "border-[#6B7280] text-[#111111]"
                  }`}
                >
                  <span>{selectedValue || label}</span>

                  <ChevronDown
                    size={18}
                    className={`transition-transform ${
                      isOpen ? "rotate-180" : "rotate-0"
                    }`}
                  />
                </button>

                {isOpen ? (
                  <div className="absolute left-0 top-[calc(100%+8px)] z-20 w-56 overflow-hidden rounded-2xl border border-[#E6E3E8] bg-white shadow-[0_16px_30px_rgba(0,0,0,0.12)]">
                    {options.map((option) => (
                      <button
                        key={option}
                        type="button"
                        onClick={() => handleSelectFilter(label, option)}
                        className={`block capitalize w-full px-4 py-3 text-left text-sm transition hover:bg-[#F5ECF4] hover:text-[#923D8C] ${
                          selectedValue === option
                            ? "bg-[#F5ECF4] font-semibold text-[#923D8C]"
                            : "text-[#111111]"
                        }`}
                      >
                        {option}
                      </button>
                    ))}
                  </div>
                ) : null}
              </div>
            );
          })}

          <button
            type="button"
            onClick={handleClearFilters}
            className="inline-flex items-center rounded-full border border-[#938A96] px-2.5 py-[4px] font-medium leading-[19px] text-[#6B7280]"
          >
            Clear Filters
          </button>
        </div>
      </div>

      <AddCourseModal
        isOpen={isAddCourseModalOpen}
        onClose={() => {
          setIsAddCourseModalOpen(false);
        }}
      />
    </div>
  );
};

export default Header;
